import React from "react";

export const SectionTitle = ({ n, en, zh, icon: Icon }) => (
  <div className="flex items-center gap-3">
    <span className="font-mono-num text-xs font-bold text-slate-950 bg-amber-400 w-6 h-6 grid place-items-center rounded-md">{n}</span>
    <Icon className="w-5 h-5 text-amber-400" />
    <h2 className="font-heading text-lg sm:text-xl font-bold">{en} <span className="font-zh text-amber-300/70 text-base">{zh}</span></h2>
  </div>
);

export const Section = ({ children }) => (
  <section className="bg-[#151D2E] rounded-2xl border border-slate-800 p-5 sm:p-6">{children}</section>
);
